export default "__VITE_ASSET__DklfY14H__"